/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] =
[
    // {
    //     id   : 'dash',
    //     title: 'Dashboard',
    //     type : 'basic',
    //     externalLink: true,
    //     link: '/dashboard'
    // },
    // {
    //     id   : 'cart',
    //     title: 'My cart',
    //     type : 'basic',
    //     externalLink: true,
    //     link: '/cart'
    // },
    {
        id   : 'contact-us',
        title: 'Contact us',
        type : 'basic',
        externalLink: true,
        target: "_blank",
        link: '/contact'
    },
];

export const horizontalNavigationLoggedIn: FuseNavigationItem[] =
[
   
];

export const defaultNavigationLoggedIn: FuseNavigationItem[] = [
    {
        id   : 'home',
        title: 'Home',
        type : 'basic',
        externalLink: true,
        link: '/'
    },
    {
        id   : 'dash',
        title: 'Dashboard',
        type : 'basic',
        externalLink: true,
        link: '/dashboard'
    },
    {
        id   : 'cart',
        title: 'My cart',
        type : 'basic',
        externalLink: true,
        link: '/cart'
    },
    {
        id   : 'contact-us',
        title: 'Contact us',
        type : 'basic',
        externalLink: true,
        target: "_blank",
        link: '/contact'
    },
];

export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
